import type { LoadListTableRow } from "../load-list-row-model"
import { backlogListSourceNames } from "../../../../../../../../../../../../../../../api/kehrblatt/backlog-lists"

export const rowHints = (row: LoadListTableRow) => {
  const errors = [
    ...new Set([
      ...(row.backlogResolution?.matchReason === "number_address_conflict"
        ? [
            `Nummer ${row.backlogResolution.customerNumber} aus ${row.backlogResolution.sourceSystem ? backlogListSourceNames[row.backlogResolution.sourceSystem] : "der Liste"} passt nicht zur Adresse ${row.backlogResolution.address ?? "der Quellzeile"}. Bitte Liegenschaft und Einheit prüfen.`,
          ]
        : []),
      ...(row.needsAttention || row.backlogResolution
        ? [
            row.needsUnitSelection
              ? "Bitte eine Einheit auswählen."
              : row.backlogResolution?.matchReason === "address_unverifiable"
                ? "Adresse nicht eindeutig lesbar. Bitte die Liegenschaft zuordnen."
                : "Bitte die Liegenschaft zuordnen.",
          ]
        : []),
      ...(row.configurationError ? [row.configurationError] : []),
    ]),
  ]
  const warnings = [
    ...new Set([
      ...(row.workWarnings ?? []),
      ...(row.openWorkOrderWarning
        ? [
            `Bereits offene Aufträge: ${row.openWorkOrderWarning.labels.join("; ")}. Bitte Doppelaufträge vermeiden.`,
          ]
        : []),
      ...(row.openWorkOrderWarningState === "failed"
        ? ["Offene Aufträge konnten nicht geprüft werden. Bitte vor dem Anlegen kontrollieren."]
        : []),
    ]),
  ]
  const pending =
    row.openWorkOrderWarningState === "loading" ||
    (!row.openWorkOrderWarningState && row.openWorkOrderWarningLoading)

  return {
    errors,
    warnings,
    label: errors.length
      ? "Angaben fehlen"
      : warnings.length
        ? `Prüfen · ${warnings.length}`
        : pending
          ? "Wird geprüft"
          : row.openWorkOrderWarningState === "pending" || !row.openWorkOrderWarningState
            ? "Noch nicht geprüft"
            : "Keine Hinweise",
    color: errors.length ? "red" : warnings.length ? "amber" : pending ? "blue" : "neutral",
  }
}
